const React = require("react");
const withState = require("../../../../../utils/withState");
const {account$} = require("../../../../../emitters/account");
const Loading = require("../../../../dumb/Loading");
const Menu = require("../../../../dumb/Menu/B");

const {
  signOut,
} = account$;

module.exports = withState(() => {
  return (state) => {
    const account = state.account || {};

    return (
      <div className="h140 h80@m layoutRow fhaB fvaC">
        <div className="layoutRow fhaS fvaC">
          {state.loadingReconnect ? (
            <>
              <div className="sq50 rlv c0>.CircularProgress">
                <Loading/>
              </div>
              <div className="pl15">Reconnection...</div>
            </>
          ) : null}
        </div>
        {account && (
          <div className="layoutRow">
            <div>
              {account.login}
            </div>
            <a href="#" className="ml10 tdN ttU" onClick={(e) => {
              e.preventDefault();
              signOut();
            }}>
              Logout
            </a>
          </div>
        )}
        {/*{*/}
        {/*  account ? (*/}
        {/*    <Menu*/}
        {/*      transformOriginTop="right top"*/}
        {/*      transformOriginBottom="right bottom"*/}
        {/*      items={[{*/}
        {/*        name: <span className="cEE4F4F">Logout</span>,*/}
        {/*        onClick: signOut*/}
        {/*      }]}*/}
        {/*    >*/}
        {/*      <div className="sq60 r50% crPointer">*/}
        {/*        <img className="sq r50%" src={require("../assets/face.jpg")} alt="avatar"/>*/}
        {/*      </div>*/}
        {/*    </Menu>*/}
        {/*  ) : null*/}
        {/*}*/}
      </div>
    )
  }
}, {
  account: account$
})